<template>
    <v-slide-x-reverse-transition>
        <div v-show="dragging" class="delete-dragging" @mouseup="$emit('mouseup')"
            :style="`bottom: ${bottom}px; right: ${right}px; width: ${size}px; height: ${size}px;`">
            <v-icon color="error" size="24">$delete</v-icon>
        </div>
    </v-slide-x-reverse-transition>
</template>

<script>
export default {
    props: {
        dragging: {
            type: Boolean,
            default: false,
        },
        bottom: {
            type: [Number, String],
            default: 12,
        },
        right: {
            type: [Number, String],
            default: 24,
        },
        size: {
            type: [Number, String],
            default: 52,
        }
    },

}
</script>

<style scoped>
.delete-dragging {
    position: fixed;
    border-radius: 50%;
    background: rgba(232, 92, 92, 0.15);
    border: 2px solid var(--v-error-base);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    cursor: pointer;
    animation: delete-pulse 1.2s ease-in-out infinite;
    transition: background 0.15s, transform 0.15s;
}

.delete-dragging:hover {
    background: rgba(232, 92, 92, 0.35);
    transform: scale(1.15);
    animation: none;
}

@keyframes delete-pulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(232, 92, 92, 0.5); }
    50% { box-shadow: 0 0 0 12px rgba(232, 92, 92, 0); }
}
</style>
